import { render, staticRenderFns } from "./autoRefundRecord.vue?vue&type=template&id=3bf27dc1&scoped=true"
import script from "./autoRefundRecord.vue?vue&type=script&lang=js"
export * from "./autoRefundRecord.vue?vue&type=script&lang=js"
import style0 from "./autoRefundRecord.vue?vue&type=style&index=0&id=3bf27dc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf27dc1",
  null
  
)

export default component.exports